import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NotificationSystem from 'react-notification-system';

import Icon from 'constants/icons';

const mapStateToProps = (state) => ({
    message: state.notificationItemReducer.message,
    level: state.notificationItemReducer.level,
    icon: state.notificationItemReducer.icon,
    id: state.notificationItemReducer.id,
});

const CustomNotificationContainer = ({ icon, message, level, id }) => {
    const notificationSystem = React.useRef();
    React.useEffect(() => {
        if (notificationSystem.current) {
            const notification = notificationSystem.current;
            notification.addNotification({
                message: <pre style={{ fontFamily: 'calibri', color: 'rgb(0,0,0)', fontSize: 14 }}>{message}</pre>,
                level,
                position: 'tc',
                autoDismiss: 10,
            });
        }
    }, [id]);

    return message && <NotificationSystem ref={notificationSystem} />;
};

CustomNotificationContainer.propTypes = {
    message: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired,
    // icon: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, null)(CustomNotificationContainer);
